import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { Esito } from '../../../models/esito';
import { SezioneEsitiFull } from '../../../models/sezioni/sezione-esiti-full';
import { EsitiAddComponent } from './esiti-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [esiti-add]',
  templateUrl: 'esiti-add-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})
export class EsitiAddMod {

    @Output()
    onReturn: EventEmitter<SezioneEsitiFull> = new EventEmitter<SezioneEsitiFull>();

    @ViewChild('formAdd')
    formAdd: EsitiAddComponent;

    @Output()
    onEsitoInseritoForAuto: EventEmitter<Esito> = new EventEmitter<Esito>();

    @Output()
    lastID: EventEmitter<string> = new EventEmitter<string>();


    isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();

  inizializza(urlAddEsito: string, idSezione: string, fascicolo: FascicoloFull, urlReadSezioneControparti: string, urlReadSezioneAltreParti: string, urlReadSezioneLegali:string) {
    if(this.isPrd) this.formAdd.inizializza(urlAddEsito, idSezione, fascicolo, urlReadSezioneControparti, urlReadSezioneAltreParti, urlReadSezioneLegali);
    openModal('modaladd');
  }

  createForm() {
    if(this.isPrd) this.formAdd.createForm();
  }

  manageModal(sezione: SezioneEsitiFull) {
      closeModal('modaladd');
      this.onReturn.emit(sezione);
  }

  eventoEsitoInseritoForAuto(esitoIns: Esito){
    this.onEsitoInseritoForAuto.emit(esitoIns);
  }

  getLastID(lastID){
    this.lastID.emit(lastID)
  }

}
